import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import Quiz from '../components/Quiz.vue'
import Aboutme from '../components/Aboutme.vue'
import viewVideos from '../components/viewVideos.vue'
import viewVideos1 from '../components/viewVideos1.vue'
import viewVideos2 from '../components/viewVideos2.vue'
import jimp from '../components/jimp.vue'
import loginGoogle from '../components/loginGoogle.vue'
import Privacy from '../components/Privacy.vue'
import SocialMedia from '../components/SocialMedia.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: loginGoogle
  },
  {
    path: '/quiz',
    name: 'Quiz',
    component: Quiz
  },
  {
    path: '/aboutme',
    name: 'Aboutme',
    component: Aboutme
  },
  {
    path: '/privacypolicy',
    name: 'PrivacyPolicy',
    component: Privacy
  },
  {
    path: '/socialmedia',
    name: 'socialmedia',
    component: SocialMedia
  },
  {
    path: '/viewvideo',
    name: 'viewVideos',
    component: viewVideos
  },
  {
    path: '/viewvideo1',
    name: 'viewVideos1',
    component: viewVideos1
  },
  {
    path: '/viewvideo2',
    name: 'viewVideos2',
    component: viewVideos2
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
